import { __rest } from "tslib";
import React from 'react';
import { StyledDialog } from './styled';
export const Dialog = React.forwardRef((_a, ref) => {
    var rest = __rest(_a, []);
    return React.createElement(StyledDialog, Object.assign({ ref: ref }, rest));
});
//# sourceMappingURL=Dialog.js.map